import { jwtDecode } from 'jwt-decode';
import { clearCustomFieldsCache } from './customFieldUtils';

export interface TokenPayload {
  exp?: number;
  customer_id?: string;
  role?: string;
  permission_group?: string;
}

/**
 * Validates if a stored token is still valid
 * @param token - The JWT token to validate
 * @returns Object with validation result and decoded payload if valid
 */
export const validateStoredToken = (token: string): { isValid: boolean; payload?: TokenPayload; error?: string } => {
  try {
    const decoded = jwtDecode<TokenPayload>(token);

    // Check if token is expired
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      return { isValid: false, error: 'Token expired' };
    }

    if (!decoded.customer_id) {
      console.warn('[Auth] Token missing customer_id claim - Auth0 Action may be misconfigured');
    }

    return { isValid: true, payload: decoded };
  } catch {
    return { isValid: false, error: 'Failed to decode token' };
  }
}

/**
 * Clears any residual app-level caches before logout. The Auth0 SDK
 * manages its own token cache; this only purges derived caches.
 */
export const clearAuthData = (): void => {
  clearCustomFieldsCache();
}
